import { render } from "./CreateCalendarEvent.vue?vue&type=template&id=c8d6a8e8"
import script from "./CreateCalendarEvent.vue?vue&type=script&lang=js"
export * from "./CreateCalendarEvent.vue?vue&type=script&lang=js"

import "./CreateCalendarEvent.vue?vue&type=style&index=0&id=c8d6a8e8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__